export const extractErrorMessage = (errorData) => {
  if (!errorData) return "";

  if (errorData.data) {
    const { detail } = errorData.data;
    return Array.isArray(detail) ? detail[0].msg : detail;
  }

  if (errorData.error) return errorData.error;
  if (errorData.message) return errorData.message;

  return errorData;
};

export default { extractErrorMessage };
